import { FormControl, FormLabel, Input, VStack } from '@chakra-ui/react'

interface Props {
  firstName: string
  lastName: string
  year: string
  onFirstNameChange: (v: string) => void
  onLastNameChange: (v: string) => void
  onYearChange: (v: string) => void
}

// Keep year input as plain text so the visual chrome matches first/last name
// inputs exactly (no chevron, no native spinner). Digits-only filter applied
// in the onChange handler; submit gating requires 4 characters.
const StepYouthForm = ({ firstName, lastName, year, onFirstNameChange, onLastNameChange, onYearChange }: Props) => (
  <VStack spacing={4} align="stretch">
    <FormControl>
      <FormLabel color="whiteAlpha.800" fontSize="sm">First name</FormLabel>
      <Input
        value={firstName}
        onChange={e => onFirstNameChange(e.target.value)}
        placeholder="First name"
        color="white"
        bg="whiteAlpha.100"
        borderColor="whiteAlpha.300"
        _placeholder={{ color: 'whiteAlpha.400' }}
      />
    </FormControl>
    <FormControl>
      <FormLabel color="whiteAlpha.800" fontSize="sm">Last name</FormLabel>
      <Input
        value={lastName}
        onChange={e => onLastNameChange(e.target.value)}
        placeholder="Last name"
        color="white"
        bg="whiteAlpha.100"
        borderColor="whiteAlpha.300"
        _placeholder={{ color: 'whiteAlpha.400' }}
      />
    </FormControl>
    <FormControl>
      <FormLabel color="whiteAlpha.800" fontSize="sm">Year of birth</FormLabel>
      <Input
        value={year}
        onChange={e => onYearChange(e.target.value.replace(/\D/g, '').slice(0, 4))}
        placeholder="YYYY"
        inputMode="numeric"
        maxLength={4}
        color="white"
        bg="whiteAlpha.100"
        borderColor="whiteAlpha.300"
        _placeholder={{ color: 'whiteAlpha.400' }}
      />
    </FormControl>
  </VStack>
)

export default StepYouthForm
